<script setup>

import LoadingSpinner from '@/components/LoadingSpinner.vue';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  isLoading: {
    type: Boolean,
    required: true,
    default: false,
  },
});

</script>

<template>
  <template v-if="isLoading">
    <div
      v-bind="$attrs"
      class="w-full h-full flex items-center justify-center"
    >
      <LoadingSpinner />
    </div>
  </template>

  <template v-else>
    <slot />
  </template>
</template>
